export default __webpack_public_path__ + "static/media/ampule.4ec2e637.png";